import React, { FC } from 'react';
import { LuArrowUp } from 'react-icons/lu';
import { profile } from '../data/profile';

const Footer: FC = () => (
  <footer className="footer">
    <div className="container footer__inner">
      <p>
        © {new Date().getFullYear()} {profile.name} · {profile.brand}
      </p>
      <a href="#inicio" className="footer__top">
        Voltar ao topo <LuArrowUp size={16} />
      </a>
    </div>
  </footer>
);

export default Footer;
